import En from "images/global/countries/en.png"
import Pt from "images/global/countries/pt.png"

export const countries = {
	pt: {
		label: "Portuguese",
		image: Pt,
	},
	en: {
		label: "English",
		image: En,
	},
} as const

export const countriesOptions = Object.entries(countries).map(
	([key, value]) => ({
		value: key,
		...value,
	}),
) as {
	value: keyof typeof countries
	label: string
	image: string
}[]
